import createSpinner from "../../../Shared/Functions/createSpinner";
import swal from "sweetalert2";

export default /*@ngInject*/ function ($uibModalInstance, helperService, reasonsDataService, item) {
    const vm = this;
    vm.saveReason = saveReason;
    vm.cancel = cancel;

    activate();

    function activate() {
        if (item.Id) {
            vm.reason = { ...item.toJSON() };
        }
    }

    // Common modal functions
    function cancel() { $uibModalInstance.dismiss(); }
    function close() { $uibModalInstance.close(); }

    async function saveReason(reason) {
        vm.savePending = new createSpinner();

        let reasonToSave = {
            'Name': reason.Name
        };

        if (vm.reason.Id) {
            reasonToSave.Id = reason.Id;
        }

        try {
            if (vm.reason.Id) {
                await swal(helperService.areYouSureParams('Update Reason', `This change will be reflected in all previously completed review items where this reason was used.  Are you sure you want to proceed?`, 'Update'));
                await reasonsDataService.updateReason(reasonToSave);
            } else {
                await reasonsDataService.createReason(reasonToSave);
            }

            await helperService.successfulSaveButton(vm.savePending);
            close();
            
        } catch {
            vm.savePending.loadingValue = false;
        }
    }
}